<div class="card-header">
  <app-breadcrumb currentPage="Taken"></app-breadcrumb>
</div>

<div class="card-body">
  <table class="table full-width">
    <tbody>
      <tr *ngFor="let row of content" class="pointer" (click)="navigate(row)">
        <td>{{row.user}}</td>
        <td [title]="row.clientCreatedAt">{{row.client}}</td>
        <td>{{row.code}}{{row.year}}</td>
        <td style="width:200px; text-align: right">{{row.createdAt}}</td>
      </tr>
    </tbody>
  </table>
</div>
